import { MeetingStore, SharingState } from '../../models/meetingClass';

const initialState: MeetingStore = new MeetingStore();


export const MEETING_SET_VIDEO_MUTED = 'MEETING_SET_VIDEO_MUTED';
export const MEETING_SET_AUDIO_MUTED = 'MEETING_SET_AUDIO_MUTED';
export const MEETING_SET_SHARING_CONTENT = 'MEETING_SET_SHARING_CONTENT';
export const MEETING_SET_RECEIVING_CONTENT = 'MEETING_SET_RECEIVING_CONTENT';
export const MEETING_SET_RECEIVING_VIDEOID = 'MEETING_SET_RECEIVING_VIDEOID';
export const MEETING_SET_CONNEXION_STATE = 'MEETING_SET_CONNEXION_STATE';
export const MEETING_UPDATE_FROM_SDK = 'MEETING_UPDATE_FROM_SDK';
export const MEETING_SET_MENU_PEOPLE = 'MEETING_SET_MENU_PEOPLE';


export const MeetingReducer = (state = initialState, action) => {
  switch (action.type) {

    case MEETING_SET_VIDEO_MUTED: {
      return { ...state,
        videoMute: action.payload.videoMute};
    }
    case MEETING_SET_AUDIO_MUTED: {
      return { ...state,
        audioMute: action.payload.audioMute};
    }
    case MEETING_SET_SHARING_CONTENT: {
      return { ...state,
        sharingContent: action.payload.sharingContent,
        sharingLocalContent: action.payload.sharingLocalContent,
      };
    }
    case MEETING_SET_RECEIVING_CONTENT: {
      return { ...state,
        receivingContent: action.payload.receivingContent,
        presenterName: action.payload.presenterName,
        presenterGuid: action.payload.presenterGuid,
      };
    }
    case MEETING_SET_RECEIVING_VIDEOID: {
      return { ...state,
        currentVideoId: action.payload.videoId,
      };
    }
    case MEETING_SET_CONNEXION_STATE: {
      return { ...state,
        connexionState: action.payload.connexionState};
    }
    case MEETING_UPDATE_FROM_SDK: {
      return { ...state,
        videoMute: action.payload.videoMute,
        audioMute: action.payload.audioMute,
        receivingContent: action.payload.receivingContent,
        connexionState: action.payload.connexionState,
        sharingContent: action.payload.receivingContent ? false : state.sharingContent,
        sharingLocalContent: action.payload.receivingContent ? SharingState.NONE : state.sharingLocalContent,
      };
    }

    case MEETING_SET_MENU_PEOPLE: {
      return { ...state, selectedMenuPeople: action.payload}
    }

    default:
      return state;
  }
};
